import { getTodos, toggleTodo, removeTodo } from "./todos"
import { getFilters } from "./filters"

//render application todos based on filters
const renderTodos = function () {
    const todosEl = document.querySelector('#todos')
    const filters = getFilters()
    const todos = getTodos()
    const filteredTodos = todos.filter((todo) => {
        const searchTextMatch = todo.text.toLowerCase().includes(filters.searchText.toLowerCase())
        const hideCompletedMatch = !filters.hideCompleted || !todo.completed

        return searchTextMatch && hideCompletedMatch

    })

    const incompleteTodos = filteredTodos.filter((todo) => !todo.completed)


    todosEl.innerHTML = ''
    const summary = generateSummaryDOM(incompleteTodos)
    todosEl.appendChild(summary)

    if (filteredTodos.length > 0) {
        filteredTodos.forEach((todo) => {
            const p = generateTodoDOM(todo)
    
            todosEl.appendChild(p)
        })
    } else {
        const emptyMessage = document.createElement('p')
        emptyMessage.classList.add('empty-message')
        emptyMessage.textContent = 'No todos to show.'
        todosEl.appendChild(emptyMessage)
    }

    
}


//generate DOM structure for new todo
const generateTodoDOM = (todo) => {
    const p = document.createElement('label')
    const containerEl =document.createElement('div')
    const textEl = document.createElement('span')
    const checkbox = document.createElement('input')
    const button = document.createElement('button')

    // set up the checkbox
    checkbox.setAttribute('type', 'checkbox')
    checkbox.checked = todo.completed
    containerEl.appendChild(checkbox)
    checkbox.addEventListener('change', () => {
        toggleTodo(todo.id)
        renderTodos()
    })

    // set up the todo title text
    textEl.textContent = todo.text
    containerEl.appendChild(textEl)

    //setup container
    p.classList.add('list-item')
    containerEl.classList.add('list-item__container')
    p.appendChild(containerEl)

    // set up the remove todo button
    button.textContent = 'remove'
    button.classList.add('button', 'button--text')
    p.appendChild(button)
    button.addEventListener('click', () => {
        removeTodo(todo.id)
        renderTodos()
    })


    return p
}


const generateSummaryDOM = (incompleteTodos) => {
    const summary = document.createElement('h1')
    summary.classList.add('list-title')
    const plural = incompleteTodos.length === 1 ? '' : 's'
    summary.textContent = `You have ${incompleteTodos.length} todo${plural} left.`
    

    return summary
}

export { generateTodoDOM, generateSummaryDOM, renderTodos}